import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '@services/api.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private apiService: ApiService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.apiService.getToken();

    if(token){
      const cloned = request.clone({
        headers: request.headers.set("Authorization","Bearer " + token)
      });
      
      return next.handle(cloned).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            // Token expirado o inválido
            this.toastr.error('Sesión expirada. Por favor inicie sesión nuevamente.');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('usuario');
            sessionStorage.removeItem('colaborador');
            localStorage.removeItem('menu');
            this.router.navigate(['/login']);
          }
          return throwError(() => error);
        })
      );
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toastr.error('Por favor inicie sesión.');
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
